var m = require('mithril');
var prop = require('mithril/stream');
var loaders = require('../../layout/components/loaders');
var modal = require('../../layout/components/modal');
var modalForm = require('../../layout/components/modalForm');
var heading = require('../../components/heading');
var header = require('../../layout/components/header');
var UserForm = require('../models/userForm');
var dragscroll = require('../../libs/dragscroll');
var userModal = modalForm(UserForm);
var cloudInviteModal = require('./cloudInviteModal');
var paginationWithSearch = require('../../data/components/paginationWithSearch');
var inactiveUsersModal = require('./inactiveUserModal');
var rowActionDropdown = require('../../components/rowActionDropdown');
var requestStatusHandler = require('../../layout/components/requestStatusHandler');
var RequestStatus = require('../../layout/enums/RequestStatus');
var session = require('../models/session');

var component = {};

component.oninit = function () {
  var ctrl = this;
  header.vm.activeTab('Users');
  document.title = 'nimrod | Users';
  ctrl.newNode = prop(false);
  ctrl.viewInactiveUsers = prop(false);
  ctrl.identityMode = prop('local');
  ctrl.requestStatus = prop(RequestStatus.PENDING);
  ctrl.requestStatusCode = prop();
  ctrl.init = function () {};

  if (!session.isSuperuser()) {
    ctrl.requestStatusCode(403);
    ctrl.requestStatus(RequestStatus.ERROR);
    return;
  }
  
  ctrl.init = function () {
    ctrl.requestStatus(RequestStatus.PENDING);
    ctrl.requestStatusCode();
    Promise.all([
      loaders.requestWithLoader({
        url: "/api/v1/user",
        method: "GET"
      }),
      loaders.requestWithLoader({
        url: "/api/v1/user/identity-mode",
        method: "GET"
      }).catch(function () { return { mode: 'local' }; })
    ]).then(function(results){
      var result = results[0];
      ctrl.identityMode(results[1].mode === 'entra' ? 'entra' : 'local');
      result.forEach(r => r.name = r.firstName + ' ' + r.lastName);
      result.sort((a, b) => a.name.localeCompare(b.name));
      ctrl.users = result.filter(r => !r.inactive || r.inactive == "0");
      ctrl.inactiveUsers = result.filter(r => r.inactive && r.inactive == "1");
      ctrl.newNode(true);
      ctrl.requestStatus(RequestStatus.SUCCESS);
      m.redraw();
    }).catch(function (error) {
      ctrl.requestStatusCode(error && (error.status || error.code || (error.response && error.response.status)));
      ctrl.requestStatus(RequestStatus.ERROR);
      m.redraw();
    });
  };
  ctrl.usersToShow = [];

  modal.on('closed', ctrl.init);
  
  ctrl.init();

  ctrl.toogleView = () => {
    ctrl.viewInactiveUsers(!ctrl.viewInactiveUsers());
    ctrl.newNode(true);
  }
};

component.onremove = function () {
  modal.off('closed', this.init);
};

component.view = function () {
  var ctrl = this
  if (ctrl.requestStatus() !== RequestStatus.SUCCESS || !ctrl.users) {
    return m(requestStatusHandler, {
      requestStatus: ctrl.requestStatus,
      requestStatusCode: ctrl.requestStatusCode,
    });
  }
  return m('div.mh3', [
    m(heading, {
      label:`${ctrl.viewInactiveUsers() ? 'Inactive' : ''} Users`, 
      class:'f-subheadline mb3 pb1 display items-center'
    },[
      m(rowActionDropdown, {
        items: [
          {
            label: ctrl.identityMode() === 'entra' ? 'Invite User' : 'Add User',
            icon: 'ion-plus',
            onclick: () => ctrl.identityMode() === 'entra'
              ? cloudInviteModal.editDialogue({ submitCallback: ctrl.init })
              : userModal.editDialogue({})
          },
          {
            label: `Show ${ctrl.viewInactiveUsers() ? 'Active': 'Inactive'} Users`,
            icon: 'ion-ios-person-outline',
            onclick: () => ctrl.toogleView()
          }
        ]
      })
    ]),
    m(paginationWithSearch, {
      data: ctrl.viewInactiveUsers() ? ctrl.inactiveUsers : ctrl.users,
      newNode: ctrl.newNode,
      dataToShow: ctrl.usersToShow,
      placeHolder: 'Search user',
      itemsPerPage: 30,
      fieldsToSearch: ['firstName', 'email', 'lastName']
    },[
      m('div.overflow-hidden',[
        m('div.dragscroll-container', [
          m('div.dragscroll', {oncreate:dragscroll}, [
            m('table.w-100.f4.mb4.pt3.mr4', { style: { tableLayout: 'fixed', minWidth: '820px' } }, [
              m('colgroup', [
                m('col', { style: { width: '280px' } }),
                m('col', { style: { width: '300px' } }),
                m('col', { style: { width: '150px' } }),
                m('col', { style: { width: '90px' } }),
              ]),
              m('thead', [
                m('tr', [ 
                  m('th.ph0.tl', { style: { width: '280px', maxWidth: '280px' } }, 'Name'),
                  m('th.ph0.tl', 'Email'),
                  m('th.ph0.tl', 'Phone'),
                  m('th.ph0.tl', 'Superuser')
                  //m('th.ph0.tl', 'SSO')
                ])
              ]),
              m('tbody', [
                ctrl.usersToShow.map(function (user) {
                  if(!user['@rid']){
                    return m('tr', [
                      m('td.tl.nowrap', { style: { width: '280px', maxWidth: '280px' } }, [
                        m('label',{style:{'visibility':'hidden'}}, 'No Data')
                      ]),
                      m('td.tl.nowrap'),
                      m('td.tl.nowrap'),
                      //m('td.tl.nowrap'),
                      m('td.tl.nowrap')
                    ])
                  }else{
                    return m('tr', [
                      m('td.tl.nowrap', { style: { width: '280px', maxWidth: '280px' } }, [
                        m('div.flex.items-center.justify-between', [
                          m('span.mr3.flex-auto', { style: { minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis' } }, user.name),
                          m('span.flex-none', [
                            ctrl.identityMode() === 'entra' ?
                              m('span.gray.f6', 'Managed in Nimrod Cloud') :
                              m(rowActionDropdown, {
                              buttonClass: 'dib mr3',
                              items: [
                                {
                                  label: 'Edit User',
                                  icon: 'ion-ios-compose',
                                  onclick: function () { m.route.set('/user/' + user['@rid'].slice(1)); }
                                },
                                {
                                  label: `${ctrl.viewInactiveUsers() ? 'Active' : 'Deactivate'} User`,
                                  icon: 'ion-ios-compose',
                                  onclick: function () { inactiveUsersModal.editDialogue(user); }
                                }
                              ]
                            })
                          ])
                        ])
                      ]),
                      m('td.tl.nowrap.overflow-hidden', { style: { textOverflow: 'ellipsis' } }, user.email),
                      m('td.tl.nowrap.overflow-hidden', { style: { textOverflow: 'ellipsis' } }, user.sms),
                      //m('td.tl.nowrap', 'No'),
                      m('td.tl.nowrap', [
                        user.isSuperuser == 1 ?  
                          m('i.f2.ml2.ion-android-checkbox-outline.green.pointer') 
                        : 
                          m('i.f2.ml2.ion-android-checkbox-outline-blank.gray.pointer')
                      ])
                    ])
                  }
                })
              ])
            ])
          ])
        ])
      ])
      
      
    ])
    
  ]);
};

module.exports = component;
